import { EEL, WHITE, DARK_SKY, MOBILE, TABLET } from '../../theme';

export const inputTheme = {
  Input: `
    border-radius: 3.125rem;
    border: none;
    min-height: 3rem;
    max-width: 18.75rem;
    background-color: black;
    color: ${WHITE};
    ::placeholder{
      color: ${{WHITE}};
      font-size: 1rem;
    }
    :focus {
      outline: none;
    }
    @media (max-width: ${TABLET}) {
      max-width: 18.75rem;
    }
    @media (max-width: ${MOBILE}) {
      border-radius: 0.8rem 0 0 0.8rem;
      max-width: 11rem;
    }
  `,
  Button: `
    background-color: ${EEL};
    color: ${DARK_SKY};
    border-radius: 3.125rem;
    margin-left: 1.25rem;
    font-weight: 600;
    height: 3rem;
    transition: 500ms ease;
    :hover{
      transform: translateY(-2px);
      box-shadow: rgba(0, 0, 0, 0.8) 0px 5px 10px 0px;
      background-color: ${EEL};
    }
    :focus {
      outline: none;
    }
    @media (max-width: ${MOBILE}) {
      border-radius: 0 0.8rem 0.8rem 0;
      margin-left: 0;
      min-width: 5rem;
    }
  `,
};